import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

export const UserMenu: React.FC = () => {
  const { user, logout, isAdmin, isStaff } = useAuth()
  const [isOpen, setIsOpen] = useState(false)

  if (!user) return null

  const handleLogout = async () => {
    await logout()
    setIsOpen(false)
  }

  const getRoleBadge = () => {
    if (isAdmin) {
      return <span className="px-2 py-1 text-xs font-semibold text-white bg-red-600 rounded-full">Admin</span>
    }
    if (isStaff) {
      return <span className="px-2 py-1 text-xs font-semibold text-white bg-blue-600 rounded-full">Staff</span>
    }
    return null
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-3 text-gray-700 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md p-2"
      >
        <div className="text-right">
          <div className="text-sm font-medium">{user.name}</div>
          <div className="text-xs text-gray-500">{user.email}</div>
        </div>
        <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
          <span className="text-sm font-medium text-gray-700">
            {user.name.charAt(0).toUpperCase()}
          </span>
        </div>
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg z-20 border border-gray-200">
            <div className="py-1">
              <div className="px-4 py-3 border-b border-gray-100">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-sm font-medium text-gray-900">{user.name}</div>
                    <div className="text-sm text-gray-500">{user.email}</div>
                  </div>
                  {getRoleBadge()}
                </div>
              </div>
              
              <div className="py-1">
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                >
                  Sign out
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
